import React from "react"

import ApplicationStepper from "@/components/application/ApplicationStepper"
import Orientation from "@/components/application/Orientation"
import AppLayout from "@/components/layout/AppLayout"

const OrientationPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 pb-8 md:px-8">
        <ApplicationStepper />

        <h1 className="mb-2 text-center text-2xl font-bold text-jungle md:text-2xl">Orientation</h1>
        <p className="mb-8 text-center text-gray-600">
          Choose a convenient time for your orientation session
        </p>

        <div className="mx-auto max-w-2xl">
          <Orientation />
        </div>
      </div>
    </AppLayout>
  )
}

export default OrientationPage
